
// const formatPriceWithCommas = (value) => {
//   return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
// };

// const PriceInput = ({ label='', labelClass='', inputClass='', placeholder='', value, onChange }) => {
//   // const handleChange = (e) => {
//   //   const { value } = e.target;
//   //   const numericValue = value.replace(/,/g, ""); // Remove commas to get the numeric value
//   //   if (!isNaN(numericValue)) {
//   //     onChange(numericValue);
//   //   }
//   // };

//   const handleChange = (e) => {
//     const { value } = e.target;
//     const numericValue = value.replace(/,/g, "").replace(/-/g, "");; // Remove commas to get the numeric value
//     if (!isNaN(numericValue)) {
//       onChange(numericValue);
//     }
//   };
//   const displayValue = formatPriceWithCommas(value);

//   return (
//     <>
//       <label className={labelClass}>{label}</label>
//       <div className="input-group mb-3">
//         <input
//           type="text"
//           id={label}
//           className={inputClass}
//           placeholder={placeholder}
//           value={displayValue}
//           onChange={handleChange}
//         />
//         <div className="input-group-append border-left-0 rounded-0">
//           <span className="input-group-text bg-transparent rounded-0 rounded-end" id="basic-addon2">UZS</span>
//         </div>
//       </div>
//     </>
//   );
// };

// export default PriceInput;

const formatPriceWithCommas = (value) => {
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

const PriceInput = ({ label='', labelClass='', inputClass='', placeholder='', value, onChange }) => {
  const handleChange = (e) => {
    let { value } = e.target;
    let numericValue = value.replace(/,/g, "").replace(/-/g, "").replace(/\D/g, ""); // Remove commas, dashes, and non-numeric characters
    
    // if (!isNaN(numericValue) && numericValue !== "") {
    //   onChange(numericValue);
    // }
    if (numericValue === "") {
      onChange("");  // Set value to empty string instead of keeping last digit
    } else {
      onChange(numericValue);
    }
  };

  const displayValue = value ? formatPriceWithCommas(value) : "";

  return (
    <>
      <label className={labelClass}>{label}</label>
      <div className="input-group mb-3">
        <input
          type="text"
          id={label}
          className={inputClass}
          placeholder={placeholder}
          value={displayValue}
          onChange={handleChange}
        />
        <div className="input-group-append border-left-0 rounded-0">
          <span className="input-group-text bg-transparent rounded-0 rounded-end" id="basic-addon2">UZS</span>
        </div>
      </div>
    </>
  );
};

export default PriceInput;